import {AbstractSubscriptionPayment, SubscriptionConfirmationPayment} from '../subscription.confirmation.payment';
import {Lead} from '../../../../../data/domain/lead';
import {isCompleteFor, isForbiddenAgedClient, isForbiddenPreviousClient} from '../../../../../common/sessions';
import {createE164PhoneNumber} from '../../../../../common/strings';
import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {SubscriptionResources} from '../../../../../resources/subscription.resources';
import {LeadResources} from '../../../../../resources/lead.resources';
import {Option, OptionsConfig} from '../../../../../model/subscription.model';
import {RemoteConfig} from '../../../../config/remote-config';
import {SocialTrackService} from '../../../../../services/social-track.service';
import {PaymentMode} from '@minutespourtoi/api-models/dist/models';

@Injectable({
  providedIn: 'root',
})
export class PaySubscriptionInPlace extends AbstractSubscriptionPayment implements SubscriptionConfirmationPayment {

  leadResources = inject(LeadResources)
  remoteConfig = inject(RemoteConfig)
  payInPlaceOption: Option

  constructor() {
    super(inject(SubscriptionResources), inject(PLATFORM_ID), inject(SocialTrackService));
    this.initOptionsConfig()
  }

  async initOptionsConfig() {
    const optionsConfig = await this.remoteConfig.getObject<OptionsConfig>("optionsConfig")
    const options = optionsConfig.options
    this.payInPlaceOption = options.find(optionIn => optionIn.code == "pay_in_place")
  }

  isEligible(): boolean {
    return this.sessionDTO.authorizedPaymentModes?.includes(PaymentMode.in_place)
  }

  async pay(): Promise<any> {

    this.socialTrackService.trackGAEvent('pay_in_place')
    if (this.checkEligibility() && this.checkContext() && this.checkPaymentAndPrice()) {
      const leadDTO = this.leadResources.currentLead.value()
      const isComplete = isCompleteFor(this.sessionDTO, leadDTO)
      const forbiddenAge = isForbiddenAgedClient(this.sessionDTO, leadDTO?.age)
      const isUnauthorized = isForbiddenPreviousClient(this.sessionDTO, this.subscriptionResources.calculatePrice.value()?.oldClient)
      const phoneNumber = this.context.confirmationForm ? createE164PhoneNumber(this.context.confirmationForm.controls.phone.value) : leadDTO.phone

      if (!isComplete && !forbiddenAge && !isUnauthorized) {
        if (this.subscriptionResources.calculatePrice.value()?.totalDiscount === 0 || this.referralCode != null) {
          await this.confirmAndThanks(leadDTO)
        } else {
          this.context.paymentContext.set({
            authenticationInProgress: true, loading: true, captured: false, error: null, orderCreated: false, loaded: false
          })
          await this.authByPhone.authenticate(phoneNumber, async (isSuccess) => {
            if (isSuccess) {
              this.context.paymentContext.set({
                authenticationInProgress: false, loading: false, captured: false, error: null, orderCreated: false, loaded: false
              })
              await this.confirmAndThanks(leadDTO)
            } else {
              this.actions.failWithMessage("Erreur d'authentification par télephone, veuillez retenter.", null)
            }
          })
        }
      } else if (isComplete){
        await this.actions.waitSubscriptionOnCompleteAge()
      } else if(forbiddenAge) {
        await this.actions.waitSubscriptionOnForbiddenAge()
      } else if(isUnauthorized) {
        await this.actions.waitSubscriptionOnUnauthorizedOldClient()
      }
    }

  }

  private async confirmAndThanks(leadDTO: Lead) {

    this.context.paymentContext.set({loaded: false, orderCreated: false, loading: true, error: null, captured: false, authenticationInProgress: false})
    if (!leadDTO.options) {
      leadDTO.options = []
    } else if (!leadDTO.options.some(optionIn => optionIn.code == "pay_in_place")) {
      leadDTO.options.push(this.payInPlaceOption)
    }
    await this.actions.sendSubscriptionAndThanks(leadDTO, 'in_place')
  }

}
